import { render } from "./CoursesPage.vue?vue&type=template&id=51bb368e"
import script from "./CoursesPage.vue?vue&type=script&lang=js"
export * from "./CoursesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__